<div style="padding: 1.2rem 0 0.8rem 0">
    <span class="table-header-wrapper">
        <b
            ><span *ngIf="displayList">Liste des&nbsp;</span
            >{{ legendePluriel }}&nbsp;
            <span style="text-decoration: underline" *ngIf="displayDate"
                >mises à jour au {{ currentDate }}</span
            >
        </b>
    </span>
</div>
